/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Flex, Image } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import CollCardInfo4 from '@eternal/Components/Card/CollCardInfo4';
import SectionTitle from '@eternal/Components/Headings/SectionTitle';
import MidContainer from '@eternal/Components/Layout/MidContainer';

/* Services */
/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const Collaborators = ({ sectionContent, region, lang }) => {
  // const settings = {
  //   className: 'slider variable-width',
  //   dots: false,
  //   infinite: true,
  //   slidesToShow: 2.5,
  //   slidesToScroll: 1,
  //   // lazyLoad: true,
  //   // variableWidth: true,
  //   responsive: [
  //     {
  //       breakpoint: 2000,
  //       settings: {
  //         slidesToShow: 2.5,
  //         centerMode: false,
  //       },
  //     },
  //     {
  //       breakpoint: 1500,
  //       settings: {
  //         slidesToShow: 1.9,
  //         centerMode: false,
  //       },
  //     },
  //     {
  //       breakpoint: 1150,
  //       settings: {
  //         slidesToShow: 1.6,
  //         centerMode: false,
  //       },
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 1.2,
  //         centerMode: true,
  //       },
  //     },
  //     {
  //       breakpoint: 500,
  //       settings: {
  //         slidesToShow: 1.01,
  //         centerMode: true,
  //       },
  //     },
  //   ],
  // };
  const settings = {
    className: 'slider variable-width',
    dots: false,
    arrows: false,
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
  };
  const findElement = param =>
    sectionContent.find(el => el._modelApiKey === param);

  return (
    <Box width="100%" maxW="100%" overflow="hidden">
      <MidContainer w="100%" px={{ '2xl': '0' }}>
        <SectionTitle titleObj={findElement('section_title')} />
        <Box w="100%" pl={{ base: '20px', md: '5%', '2xl': '0' }}>
          <Box
            className="collaborators-slider"
            maxH={{ base: 191, sm: 320, md: 445, '2xl': 547 }}
            overflow="hidden"
          >
            <Slider {...settings}>
              {findElement('gallery').images?.map(el => (
                <Box
                  key={nanoid()}
                  w="auto"
                  pr="10px"
                  h={{ base: 191, sm: 300, md: 425, '2xl': 527 }}
                >
                  <Image
                    width="auto"
                    src={el.url}
                    height="100%"
                    objectFit="cover"
                  />
                </Box>
              ))}
            </Slider>
          </Box>
          <Box maxW={1240} mr="auto" ml={{ base: '0', '2xl': 'auto' }} w="100%">
            <Flex
              justifyContent="space-between"
              alignItems={{ base: 'flex-start', md: 'center' }}
              flexWrap="wrap"
              flexDir={{ base: 'column', lg: 'unset' }}
              pr="16px"
              pl={{ '2xl': '0' }}
            >
              {findElement('card_info4_column_group').cards.map(
                (card, index) => (
                  <CollCardInfo4 card={card} key={nanoid()} index={index} />
                )
              )}
            </Flex>
          </Box>
        </Box>
      </MidContainer>
    </Box>
  );
};

export default Collaborators;
